import {Main} from '../../components/main/main.tsx';
import {CredentialResponse, GoogleLogin, GoogleOAuthProvider} from '@react-oauth/google';
import {googleLogin} from '../../store/slices/exchange_token_slice.ts';
import {useAppDispatch, useAppSelector} from '../../store/store.ts';
import {useNavigate} from 'react-router-dom';
import {isFulfilled} from '@reduxjs/toolkit';
import {loginRedirectRoute} from '../../support/login_redirect_route.ts';
import {Hero} from '../../components/hero/hero.tsx';
import {Page} from '../../components/page/page.tsx';
import {Card} from '../../components/card/card.tsx';
import {FlexRow} from '../../components/utility/flex_row.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {__} from '../../support/lang/translations.ts';
import {Spacer} from '../../components/utility/spacer.tsx';

export function LoginWithGoogle() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appConfig = useAppSelector((state) => state.appConfig.appconfig);
    const googleId = appConfig?.show_google_login && appConfig?.google_id;
    const onLoginSuccess = async (response: CredentialResponse) => {
        if (response.credential) {
            const result = await dispatch(googleLogin(response.credential));
            if (isFulfilled(result) && result.payload.googleLogin) {
                navigate(loginRedirectRoute(result.payload.googleLogin));
            }
        }
    };

    return (
        <Main className="google-login">
            <Hero
                url={appConfig?.loginscreen}
                urls={[appConfig?.sliderphoto1, appConfig?.sliderphoto2, appConfig?.sliderphoto3]}
            />
            <Page>
                <Card style={{width: '100%', maxWidth: 400, marginTop: '-4rem', zIndex: 998}}>
                    <FlexRow alignment={Alignment.Center}>
                        <h2 style={{textAlign: 'center'}}>{__('login.titles.google')}</h2>
                    </FlexRow>
                    <Spacer style={{height: '3rem'}} />
                    {googleId && (
                        <GoogleOAuthProvider clientId={googleId}>
                            <GoogleLogin onSuccess={onLoginSuccess} />
                        </GoogleOAuthProvider>
                    )}
                </Card>
            </Page>
        </Main>
    );
}
